import Header from './components/Layout/Header'
import Footer from './components/Layout/Footer'
import GetInTouch from './components/GetInTouch/GetInTouch'
import { LanguageProvider } from './contexts/LanguageContext'
import { CurrencyProvider } from './contexts/CurrencyContext' // Import the CurrencyProvider
import { Outlet } from 'react-router-dom'

export default function RootLayout() {
  return (
    <div>
      <LanguageProvider>
        <CurrencyProvider>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-grow">
              <Outlet /> {/* React Router nested pages render here */}
            </main>
            <GetInTouch />
            <Footer />
          </div>
        </CurrencyProvider>
      </LanguageProvider>
    </div>
  )
}